import { z } from "zod";

export const relativeReportingPresets = {
  yesterday: "Yesterday",
  thisWeek: "This week",
  lastWeek: "Last week",
  last7: "Last 7 days",
  last30: "Last 30 days",
  thisMonth: "This month",
  lastMonth: "Last month",
  ytd: "YTD",
} as const;

// An allowlist deliberately excludes dates, details and personal table preferences.
export const workspaceDefaultSchema = z.object({
  view: z.enum(["overview", "campaign", "creative"]),
  preset: z.enum(
    Object.keys(relativeReportingPresets) as [
      keyof typeof relativeReportingPresets,
      ...(keyof typeof relativeReportingPresets)[],
    ],
  ),
  grouping: z.enum(["day", "week", "month"]),
  platform: z.enum(["all", "meta", "google", "tiktok", "snapchat"]),
  segment: z.union([z.literal("all"), z.uuid()]),
  breakdown: z.array(z.uuid()).max(100),
  comparisonMode: z.enum(["none", "period", "wow", "mom"]),
  deltas: z.enum(["hidden", "percent", "absolute"]),
});
export type WorkspaceDefault = z.infer<typeof workspaceDefaultSchema>;

// Reads a saved Company default. A section that no longer exists (such as the
// retired Insights tab) opens Overview, like an unknown `view` in a link, rather
// than failing the whole configuration read. Saving still requires a known section.
export const storedWorkspaceDefaultSchema = workspaceDefaultSchema.extend({
  view: workspaceDefaultSchema.shape.view.catch("overview"),
});
